import { $t } from '@/i18n';
import { formatObjectToJSON } from '@utils/common';
import { openConflictModal } from '@components/merge/index';
import { merge } from 'node-diff3';
import { message } from '@utils/wuji-message';
import { omit } from 'lodash';
export const OMIT_COMPARE_FIELDS = ['_ctime', 'creator', '_mtime', '_id', 'modifier', 'ctime', 'mtime'];
/**
 * 三路合并json对象(带冲突合并UI)
 */
export const nodeDiff3Object = async (baseObj, localStr, remoteStr) => {
    const base = JSON.stringify(omit(baseObj, OMIT_COMPARE_FIELDS), null, '\t');
    const local = JSON.stringify(omit(localStr, OMIT_COMPARE_FIELDS), null, '\t');
    const remote = JSON.stringify(omit(remoteStr, OMIT_COMPARE_FIELDS), null, '\t');
    return nodeDiff3Text(base, remote, local, { type: 'json' });
};
/**
 * 三路合并文本(带冲突合并UI)
 */
export const nodeDiff3Text = async (base, remote, local, options) => {
    const { showTip = true, type = 'json', remainEmptyLine, showMerged } = options || {};
    const format = (text) => {
        if (remainEmptyLine) {
            return text?.split('\n');
        }
        return text;
    };
    const result = merge(format(local), format(base), format(remote), {
        stringSeparator: /[\r\n]+/,
    });
    if (!result.conflict) {
        showTip && message.info($t('k_13c95a70'));
        const data = type === 'json' ? JSON.parse(result.result.join('\n')) : result.result.join('\n');
        if (showMerged) {
            return await openConflictModal({
                result,
                baseData: base,
                remoteData: remote,
                localData: local,
                type: options?.type,
            });
        }
        return {
            success: true,
            data,
        };
    }
    showTip && message.warning($t('k_e04a289d'));
    result.result = result.result.map((item) => {
        if (item === '<<<<<<<') {
            return $t('k_1ba1a0a8', { arg_0: options?.currentLabel || $t('k_c760bc65') });
        }
        if (item === '>>>>>>>') {
            return $t('k_a14e0497', { arg_0: options?.remoteLabel || $t('k_946da0be') });
        }
        return item;
    });
    const conflictSolveResult = await openConflictModal({
        result,
        baseData: base,
        remoteData: remote,
        localData: local,
        type: options?.type,
    });
    if (!conflictSolveResult.success) {
        return conflictSolveResult;
    }
    return {
        success: true,
        data: conflictSolveResult.data,
    };
};
export const getDiff3MergeData = (o, a, b) => {
    const formatter = (data) => formatObjectToJSON(data);
    const base = formatter(o);
    const local = formatter(a);
    const remote = formatter(b);
    const mergeResult = merge(local, base, remote, {
        stringSeparator: /[\r\n]+/,
    });
    return {
        data: mergeResult.result.join('\n'),
        conflict: mergeResult.conflict,
    };
};
